import Vue from 'vue';
import axios from 'axios';

import Errors from '../classes/Errors';
import store from '../../tool/store/store';

Vue.component('results-component', {
    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            errors: new Errors(),
            store,
            formCompleted: false,
            isSubmitting: false,
            resultsData: null,
            resultsAreLoading: false,
            resultsError: {
                status: false,
                message: ''
            },
            bodyText: '',
        }
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        this.toolStore = JSON.parse(localStorage.getItem('toolInfo'));
        this.setBodyText();
        this.loadResults();
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {

        /**
         * Set body text depending on the zipcode check.
         * 
         * @returns {Void}
         */
        setBodyText() {
            if (this.toolStore.kadaster.serviceAvailable) {
                this.bodyText = 'We kunnen overgaan tot actie. We hebben verbeterpunten voor je woning voor je opgesteld en we zijn werkzaam in jouw regio.';
                return;
            }
            this.bodyText = 'We kunnen nog niet overgaan tot actie, maar we geven je wel graag een overzicht van mogelijke verbeterpunten voor je woning.';
        },

        /**
         * Fetch results from API.
         * 
         * @returns {Void}
         */
        loadResults() {
            this.resultsAreLoading = true;

            let testAnswers = this.createAnswersObject();
            console.log(testAnswers);
            testAnswers[window.csrfTokenName] = window.csrfTokenValue;

            axios.post('/api/test-results', testAnswers)
                .then(response => {
                    const data = response.data;
                    this.resultsAreLoading = false;
                    this.resultsData = data;
                })
                .catch((error) => {
                    console.error(error);
                    this.resultsAreLoading = false;
                    this.resultsError.status = true;
                    this.resultsError.message = `Er is iets misgegaan met het ophalen van de resultaten. Probeer later opnieuw!`;
                });
        },

        /**
         * Fetches test results from the browser storage and builds answers object from it.
         * 
         * @returns {Object}
         */
        createAnswersObject() {

            // Fetch results from local storage.
            const toolStore = JSON.parse(localStorage.getItem('toolInfo'));

            // Create answers object.
            let answers = {};
            answers.addressLine1 = toolStore.kadaster.addressLine1;
            answers.addressLine2 = toolStore.kadaster.addressLine2;
            answers.residenceType = toolStore.questionAnswers[0].answers[0];
            answers.energyConsumption = toolStore.questionAnswers[3].answers[1];
            answers.gasConsumption = toolStore.questionAnswers[3].answers[0];
            answers.buildYear = toolStore.kadaster.buildYear;
            answers.livesHere = toolStore.kadaster.livesHere;
            answers.surface = toolStore.kadaster.surface;
            answers.familyMemberCount = 'Onbekend';
            answers.questionAnswers = toolStore.questionAnswers;

            return answers;
        },

        /**
         * Handle form submission.
         * 
         * @param {SubmitEvent} event
         * @returns {Void}
         */
        onSubmit(event) {
            const form = event.currentTarget;

            if (this.isSubmitting) {
                return;
            }

            this.isSubmitting = true;
            let formData = new FormData(form);
            formData.append('resultsData', JSON.stringify(this.resultsData));

            axios.post('/', formData)
                .then((response) => {
                    this.isSubmitting = false;
                    const result = response.data;

                    if (!result.success) {
                        this.errors.clear();
                        this.errors.record(result.data.errors);

                        // this.scrollToFirstError();
                        return;
                    }

                    // Success
                    this.formCompleted = true;
                    this.errors.clear();
                })
                .catch((error) => {
                    this.isSubmitting = false;
                    console.log(error);
                });
        }
    }
});
